import Konva from 'konva';
import { Layer } from 'konva/lib/Layer';
import { Image } from 'konva/lib/shapes/Image';
import { Text } from 'konva/lib/shapes/Text';
import { Stage } from 'konva/lib/Stage';
import { EDrainageTrenchType } from '../../shared/enum';
import variable from '../../shared/style/variable';
import { redux } from '../../store';
import { ISrcImage } from './Index';
import i18n from '../../localization';

const getText = (x: number, y: number, text: string, rotation: number, fill?: string, fontSize: number = 5) =>
    new Konva.Text({
        x,
        y,
        text,
        fontSize,
        fontFamily: 'Calibri',
        fill,
        rotation,
    });

export default (stage: Stage, images: ISrcImage) => {
    const project = redux.getState().project.data!;

    const width = 300;
    const height = 200;

    const withSecondaryDrain = !!project.drainageTrenches![1];
    const withMultipleDrainLine = project.drainageTrenches![EDrainageTrenchType.PrimaryDrainageTrench].numberOfDrainLines! > 1;

    var layer = new Layer();
    var group = new Konva.Group({
        x: (stage.width() - width) / 2,
        y: (stage.height() - height) / 2,
        width,
        height,
        draggable: true,
    });

    let image: Image;
    let slopeWidthText: Text, notInScaleText: Text, slopeLengthText: Text, wheelbasePrimaryDrainText: Text, wheelbaseSecondaryDrainText: Text[] | Text;

    if (!withMultipleDrainLine) {
        image = new Konva.Image({
            x: 0,
            y: 0,
            width: group.width(),
            height: group.height(),
            image: withSecondaryDrain ? (images.generalViewSingleWithSecondaryDrain as HTMLImageElement) : (images.generalViewSingleWithoutSecondaryDrain as HTMLImageElement),
        });
        notInScaleText = getText(220, 170, i18n.t('notInScale'), 0, undefined, 9);
        slopeWidthText = getText(80, 12, `${project.slope?.slopeWidth}`, -10);
        slopeLengthText = getText(65, 125, `${project.slope?.slopeLength}`, 33);
        wheelbaseSecondaryDrainText = getText(157, 90, `${withSecondaryDrain ? project.drainageTrenches![1].wheelbase : ''}`, 40, variable.white);
        group.add(image, slopeWidthText, notInScaleText, slopeLengthText, wheelbaseSecondaryDrainText);
    } else {
        image = new Konva.Image({
            x: 0,
            y: 0,
            width: group.width(),
            height: group.height(),
            image: withSecondaryDrain ? (images.generalViewDoubleWithSecondaryDrain as HTMLImageElement) : (images.generalViewDoubleWithoutSecondaryDrain as HTMLImageElement),
        });
        notInScaleText = getText(260, 168, i18n.t('notInScale'), 0, undefined, 9);
        slopeWidthText = getText(100, 23, `${project.slope?.slopeWidth}`, -15);
        slopeLengthText = getText(50, 135, `${project.slope?.slopeLength}`, 35);
        wheelbasePrimaryDrainText = getText(210, 148, `${project.drainageTrenches![0].wheelbase}`, -15);
        wheelbaseSecondaryDrainText = [
            getText(123, 98, `${withSecondaryDrain ? project.drainageTrenches![1].wheelbase : ''}`, 40, variable.white),
            getText(199, 53, `${withSecondaryDrain ? project.drainageTrenches![1].wheelbase : ''}`, 45, variable.white),
        ];
        group.add(image, slopeWidthText, notInScaleText, slopeLengthText, wheelbasePrimaryDrainText, ...wheelbaseSecondaryDrainText);
    }

    layer.add(group);

    return { width, height, layer };
};
